module.exports = __webpack_public_path__ + "static/media/bookmarks.ee1afba6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/bookmarks.svg
// module id = 2435
// module chunks = 7